import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const API_BASE_URL = process.env.REACT_APP_API_URL;

export const getAllMessages = createAsyncThunk(
  'message/getAllMessages',
  async ({ page, limit, search, status, active }, thunkAPI) => {
    try {
      let url = `${API_BASE_URL}dashboard/get-messages?page=${page}&limit=${limit}`;
      
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      
      if (status && status !== 'all') {
        url += `&status=${encodeURIComponent(status)}`;
      }

      if (active && active !== 'all') {
        url += `&active=${encodeURIComponent(active)}`;
      }

      const response = await axios.get(url);
      return {
        items: response.data.items,
        total: response.data.totalItems,
        currentPage: response.data.page,
        pageSize: limit,
        totalPages: Math.ceil(response.data.totalItems / limit),
        itemCount: response.data.items.length,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const replyMessage = createAsyncThunk(
  'message/replyMessage',
  async ({ messageId, replyMessage }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}dashboard/reply-message/${messageId}`,
        { replyMessage },
        {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        }
      );
      return { message: response.data.message };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteMessage = createAsyncThunk(
  'message/deleteMessage',
  async (messageId, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}dashboard/delete-message/${messageId}`);
      return { messageId, message: response.data.message };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const messageSlice = createSlice({
  name: 'message',
  initialState: {
    messages: [],
    total: 0,
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,
    itemCount: 0,
    replyLoading: false,
    replyError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllMessages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllMessages.fulfilled, (state, action) => {
        state.loading = false;
        state.messages = action.payload.items;
        state.total = action.payload.total;
        state.currentPage = action.payload.currentPage;
        state.pageSize = action.payload.pageSize;
        state.totalPages = action.payload.totalPages;
        state.itemCount = action.payload.itemCount;
      })
      .addCase(getAllMessages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      .addCase(deleteMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteMessage.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      .addCase(replyMessage.pending, (state) => {
        state.replyLoading = true;
        state.replyError = null;
      })
      .addCase(replyMessage.fulfilled, (state) => {
        state.replyLoading = false;
        state.replyError = null;
      })
      .addCase(replyMessage.rejected, (state, action) => {
        state.replyLoading = false;
        state.replyError = action.payload;
      });
  },
});

export default messageSlice.reducer;